<template>
  <div class="acomodar">
    <div class="container-fluid py-3 px-4">

      <div class="border border-1 rounded-3 p-3 mb-2 ">
        <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
          <i class="bi bi-person-lines-fill display-4 text-primary"></i>
          <div>
            <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
              REGISTRADOR DE LOS
            </p>
            <p class="mb-0 tituloResaltado fs-4 fw-bold">
              TRABAJADORES
            </p>
          </div>
        </div>
      </div>

      <button class="btn btn-success mt-1 mb-2" @click="openModal">Abrir modal</button>

        <div v-if="showModal" class="modal fade show d-block" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-sm modal-md modal-lg" role="document">
            <div class="modal-content shadow-lg rounded-4 border-0">

              <div class="modal-header bg-danger text-white rounded-top-4">
                <h5 class="modal-title fw-bold d-flex align-items-center gap-2">
                  <i class="bi bi-list-task"></i> Selecciona una opción
                </h5>
                <button type="button" class="btn-close btn-close-white" @click="closeModal"></button>
              </div>

              <div class="modal-body">

                <ul class="list-group">
                  <li v-for="(item, index) in list" :key="index"
                    class="list-group-item d-flex flex-column flex-md-row justify-content-between align-items-center gap-2 border-0 px-0 py-2">
                    <button
                      class="btn btn-warning text-dark fw-semibold d-flex align-items-center gap-2 px-3 w-100 w-md-auto"
                      :disabled="listaValidador.includes(item.nombre)" @click="aumentar(item)">
                      <i class="bi bi-plus-circle-fill"></i>
                      {{ item.nombre }}
                    </button>
                    <button class="btn btn-outline-danger d-flex align-items-center gap-2 px-3 w-100 w-md-auto"
                      @click="contraquitar(item.nombre)">
                      <i class="bi bi-x-circle"></i>
                      Quitar
                    </button>

                  </li>
                </ul>

              </div>

              <div class="modal-footer d-flex justify-content-between">
                <button class="btn btn-secondary d-flex align-items-center gap-2" @click="closeModal">
                  <i class="bi bi-door-closed"></i> Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- {{ cabecera }} -->

      <div class="border border-1 rounded-3 p-3 mb-2">

       
        <div class="col-12 d-flex justify-content-end mt-2">
          <div class="input-group buscar-estiloCuadrado" style="max-width: 350px; width: 100%;">
            <span class="input-group-text mt-3 buscar-estiloCuadrado">
              <i class="bi bi-search"></i>
            </span>
            <input class="form-control mt-3 me-2 buscar-estiloCuadrado" type="text" placeholder="Buscar trabajador..."
              v-model="filterField" @input="filtro" />
          </div>
        </div>

       
        <div class="table-responsive mx-2 mt-3">
          <table class="table table-bordered align-middle">
            <thead class="reducirTamaño">
              <tr class="bg-solimano text-white text-center text-nowrap">
                <th v-for="cabeceras in tableHeaders" :key="cabeceras.id"
                  class="text-center align-middle reducirTamaño text-nowrap">
                  <p class="m-0">{{ cabeceras.nombre }}</p>
                </th>
              </tr>
            </thead>

            <tbody>

             
              <tr v-if="loading">
                <td :colspan="tableHeaders.length" class="text-center" style="height: 250px;">
                  <div class="d-flex flex-column align-items-center justify-content-center w-100 h-100">
                    <div class="spinner-border text-warning" style="width: 3.5rem; height: 3.5rem;"></div>
                    <div class="mt-3 text-secondary fw-semibold fs-5">Cargando información...</div>
                  </div>
                </td>
              </tr>

            
              <tr v-else v-for="(trabajador, index) in trabajadoresPaginados" :key="index"
                class="text-center reducirTamaño text-nowrap">

                
                <td v-for="head in tableHeaders" :key="head.id">

              


                  <template v-if="head.nombre === 'Datos del Trabajador'">
                    <div class="text-start">
                      <div class="fw-bold">{{ trabajador.Trabajador }}</div>
                      <div class="text-muted small">{{ trabajador.NroDocumento }} • {{ trabajador.TipoDoc }}</div>
                      <div class="text-muted small">Código: {{ trabajador.CodigoTrabajador }}</div>
                    </div>
                  </template>
                    
                  <!-- EMPRESA -->
                  <template v-else-if="head.nombre === 'Empresa'">
                      <div class="text-start">
                      <div class="text-muted small">{{ trabajador.NomEmpresa }}</div>
                      <div class="text-muted small">{{ trabajador.SubSubCentroCosto }}</div>
                      <div class="text-muted small">{{ trabajador.Cargo }}</div>

                      </div>
                  </template>
             
                  <!-- FECHAS -->
                  <template v-else-if="head.nombre === 'Fecha Ini. Contrato'">
                    <input disabled type="date" class="form-control text-center text-secondary"
                      :value="trabajador.FechaIniContrato?.slice(0, 10)" />
                  </template>

                  <template v-else-if="head.nombre === 'Fecha Fin Contrato'">
                    <input disabled type="date" class="form-control text-center text-secondary"
                      :value="trabajador.FechaFinContrato?.slice(0, 10)" />
                  </template>

                  <template v-else-if="head.nombre === 'Situación'">
                    <span class="badge bg-secondary">Falta</span>
                  </template>

                  <template v-else>
                    {{ trabajador[head.nombre] }}
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
  
        <div class="d-flex justify-content-center align-items-center gap-2 my-3">
          <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
            <i class="bi bi-chevron-double-left"></i>
          </button>

          <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
            <i class="bi bi-chevron-left"></i>
          </button>

          <span class="small fw-semibold">
            Página {{ currentPage }} de {{ totalPages }}
          </span>

          <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
            <i class="bi bi-chevron-right"></i>
          </button>

          <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
            :disabled="currentPage === totalPages">
            <i class="bi bi-chevron-double-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CopiasBaseDeTrabajadores',

   data() {
    return {
      trabajadores: [],
      showModal: false,
      currentPage: 1,
      itemsPerPage: 10,
      loading: false,
      filterField: "",

      list: [
        {
          id: 1,
          nombre: "Datos del Trabajador",
        },
        {
          id: 2,
          nombre: "Empresa",
        },
        {
          id: 3,
          nombre: "Fecha Ini. Contrato",
        },

        {
          id: 4,
          nombre: "Fecha Fin Contrato",
        },

        {
          id: 5,
          nombre: "Situación",
        },

      ],
      cabecera: [
        {
          id: 1,
          nombre: "Datos del Trabajador",
        },
        {
          id: 2,
          nombre: "Empresa",
        },
       
        {
          id: 3,
          nombre: "Fecha Ini. Contrato",
        },

        {
          id: 4,
          nombre: "Fecha Fin Contrato",
        },

        {
          id: 5,
          nombre: "Situación",
        },
      ],

      listaValidador: [],
    };
  },

   mounted() {
  this.axios.get(`Trabajador/ListarTrabajadores`).then((r) => {
    this.trabajadores = [...r.data]; 
    this.currentPage = 1;
    this.loading = false;
    console.log(this.trabajadores)
  });

  this.cambiarEstadoNavbar();
  },
  computed: {
    tableHeaders() {
      return this.cabecera;
    },
    trabajadoresFiltrados() {
      const filtro = this.filterField.toLowerCase().trim();

      if (!filtro) return this.trabajadores;

      return this.trabajadores.filter(t =>
        String(t.CodigoTrabajador).toLowerCase().includes(filtro) ||
        String(t.Trabajador).toLowerCase().includes(filtro) ||
        String(t.NroDocumento).toLowerCase().includes(filtro)
      );
    },

    trabajadoresPaginados() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.trabajadoresFiltrados.slice(start, start + this.itemsPerPage);
    },

     totalPages() {
      return Math.ceil(this.trabajadoresFiltrados.length / this.itemsPerPage);
    },

  },

  methods: {
    openModal() {
      console.log("funciona");
      this.listaValidador = [];
      this.cabecera.map((elementos) => {
        this.listaValidador.push(elementos.nombre);
      });
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    cambiarEstadoNavbar() {
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

    aumentar(cabecera) {
      // this.cabecera.find((objeto) => objeto.id === cabecera.id)
      //   ? console.log(" ya existe no pudo insertarlo")
      //   : this.cabecera.push(cabecera) && this.listaValidador.push(cabecera.nombre);
      this.cabecera.find((objeto) => objeto.id === cabecera.id) ? console.log("El objeto ya existe. No se puede insertar.")
        : this.cabecera.findIndex(objeto => objeto.id > cabecera.id) !== -1
          ? (this.cabecera.splice(
            this.cabecera.findIndex(objeto => objeto.id > cabecera.id),
            0,
            cabecera
          ),
            this.listaValidador.splice(
              this.cabecera.findIndex(objeto => objeto.id > cabecera.id),
              0,
              cabecera.nombre
            ))
          : (this.cabecera.push(cabecera), this.listaValidador.push(cabecera.nombre));

    },

    contraquitar(datoEliminar) {


      this.listaValidador = this.listaValidador.filter(
        (animal) => animal != `${datoEliminar}`
      );

      this.cabecera = this.cabecera.filter((objeto) =>
        this.listaValidador.includes(objeto.nombre)
      );
    },
    filtro() {
      this.loading = true;
      this.currentPage = 1;
      setTimeout(() => {

        this.loading = false;
      }, 900);

    },
  },
};
</script>



<style scoped>
.boton-estiloCuadrado {
  padding: 0.20rem 0.55rem;
  cursor: pointer;
}

.tabla-estiloCompreso {
  padding: 0.30rem 0.55rem;

}

.bg-solimano {
  background: #1565C0;
}


.bg-solimano-table {
  background: #0080c8;
}

.btn-solimano {
  background: #0080c8;
}

.tamaño {
  font-size: 0.65rem;

  font-weight: 800;
  color: #002c5d;
}

.reducirTamaño {
  font-size: 0.65rem;
}

.modal {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  padding: 20px;
  border: 1px solid #888;
  max-width: 800px;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
</style>